import { SR_API_ACTION_GET_HIERARCHICAL_MEDIA } from 'api/actionTypes';

export default async function getHierarchicalMedia(
  { state, apiClient },
  { listingId, apartmentId },
) {
  const mediaPath = [
    'media',
    listingId ? 'byListingId' : 'byApartmentId',
    listingId || apartmentId,
  ];
  if (state.get(mediaPath)) {
    return state.get(mediaPath);
  }

  await apiClient.postWithState({
    action: SR_API_ACTION_GET_HIERARCHICAL_MEDIA,
    state: state,
    payload: {
      listingId,
      apartmentId,
    },
    onSuccess(media) {
      state.set(mediaPath, media);
      return media;
    },
  });
}
